import { render } from "./_layout.vue?vue&type=template&id=5654950b&bindings={}"
import script from "./_layout.vue?vue&type=script&lang=js"
export * from "./_layout.vue?vue&type=script&lang=js"
script.render = render

export default script